// @flow
import React from 'react';
import { Link } from 'react-router-dom';

// Components
import Button from './Button';
import { Helmet } from 'react-helmet';

// Images
import FirstBoxImage from '../images/barbecue-landing-first-box-image.jpg';
import SecondBoxImage from '../images/barbecue-landing-second-box-image.jpg';

import './BarbecueCalculatorLanding.css';
const BarbecueCalculatorLanding = () => {
  return (
    <div className="barbecue-calculator-landing-container">
      <Helmet>
        <title>Churrascômetro - Bigdelivery - Seu açougue virtual</title>
        <meta
          property="og:title"
          content="Churrascômetro - Bigdelivery - Seu açougue virtual"
        />
        <meta
          name="description"
          content="O seu melhor churrasco começa aqui!"
        />
        <meta
          name="og:description"
          content="O seu melhor churrasco começa aqui!"
        />
      </Helmet>
      <div className="barbecue-calculator-landing-banner-background">
        <Link className="barbecue-calculator-landing-banner-container" to="/bigchurrasco/meuchurrasco">
          <div className="barbecue-calculator-landing-banner-content">
            <div className="barbecue-calculator-landing-banner-button-content">
            </div>
          </div>
        </Link>
      </div>

      <div className="barbecue-calculator-landing-header">
        <div className="phrase">VEJA COMO É FÁCIL SE ORGANIZAR&nbsp;CONOSCO:</div>
      </div>

      <div className="barbecue-calculator-landing-first-box-content">
        <div className="barbecue-calculator-landing-first-box-text">
          <div className="barbecue-calculator-landing-first-box-title title">
            QUANTAS PESSOAS VÃO PARTICIPAR DO&nbsp;CHURRASCO?
          </div>
          <div className="barbecue-calculator-landing-first-box-subtitle subtitle">
            Para um encontro, entre amigos ou uma&nbsp;festa?
            <br />
            Para toda ocasião, temos um churrasco perfeito para&nbsp;você.
          </div>
        </div>

        <img
          className="barbecue-calculator-landing-first-box-image"
          src={FirstBoxImage}
          alt="churrasco-com-amigos"
        ></img>
      </div>

      <div className="barbecue-calculator-landing-second-box-content">
        <img
          className="barbecue-calculator-landing-second-box-image"
          src={SecondBoxImage}
          alt="churrasco"
        ></img>
        <div className="barbecue-calculator-landing-second-box-text">
          <div className="barbecue-calculator-landing-second-box-title title">
            NÓS TE AJUDAREMOS A ESCOLHER AS MELHORES&nbsp;CARNES
          </div>
          <div className="barbecue-calculator-landing-second-box-subtitle subtitle">
            Nós sabemos que escolher as carnes certas em um churrasco pode ser
            difícil, então nos diga as suas preferências e nós escolheremos as
            melhores carnes para&nbsp;você!
          </div>
        </div>
      </div>

      <div className="barbecue-calculator-landing-button-box-content">
        <div className="barbecue-calculator-landing-button-box-text">
          <div className="barbecue-calculator-landing-button-box-title">
            E AÍ, VAMOS FAZER UM&nbsp;CHURRASCO?
          </div>
        </div>
        <div className="barbecue-calculator-landing-button-box-button">
          <Button color="white" />
        </div>
      </div>
    </div>
  );
};

export default BarbecueCalculatorLanding;
